export default {
  SET_NO_CAMERAS(state, data) {
    state.noCameras = data;
  },
  SET_CAMERAS(state, data) {
    state.cameras = data;
  },
  SET_VESSELS_NAME(state, data) {
    state.vesselsName = data;
  },
  RESET_STATE (state, data) {
    Object.assign(state, data)
  },
};
